import type { CSSProperties } from "react";
import "./Gauge.scss";

type GaugeProps = {
  value: number;
  label?: string;
  className?: string;
};

export function Gauge({ value, label = "ready", className = "" }: GaugeProps) {
  const boundedValue = Math.min(100, Math.max(0, value));

  return (
    <div
      className={`gauge ${className}`.trim()}
      style={{ "--gauge-value": `${boundedValue * 3.6}deg` } as CSSProperties}
    >
      <div>
        <strong>{boundedValue}%</strong>
        <span>{label}</span>
      </div>
    </div>
  );
}
